import React from 'react';
import { useBranding } from '../../context/BrandingContext';

const TIER_STYLES = {
  bronze:   { bg: 'bg-[#CD7F32]/20', text: 'text-[#CD7F32]',   border: 'border-[#CD7F32]/40',  dot: 'bg-[#CD7F32]'   },
  silver:   { bg: 'bg-[#C0C0C0]/20', text: 'text-[#C0C0C0]',   border: 'border-[#C0C0C0]/40',  dot: 'bg-[#C0C0C0]'   },
  gold:     { bg: 'bg-[#FFD700]/20', text: 'text-[#FFD700]',    border: 'border-[#FFD700]/40',  dot: 'bg-[#FFD700]'    },
  platinum: { bg: 'bg-slate-200/30', text: 'text-slate-600',    border: 'border-slate-400/40',   dot: 'bg-slate-500'    },
};

const DEFAULT_LABELS = { bronze: 'Bronze', silver: 'Silver', gold: 'Gold', platinum: 'Platinum' };

export const TIER_AVATAR_BG = {
  bronze:   'bg-gradient-to-br from-[#CD7F32] to-[#8B5A1A]',
  silver:   'bg-gradient-to-br from-[#C0C0C0] to-[#808080]',
  gold:     'bg-gradient-to-br from-[#FFD700] to-[#FFA500]',
  platinum: 'bg-gradient-to-br from-[#E5E4E2] to-[#9E9E9E]',
};

export default function TierBadge({ tier, size = 'md' }) {
  const { tier_names } = useBranding();
  const labels = tier_names || DEFAULT_LABELS;
  const s = TIER_STYLES[tier] || TIER_STYLES.bronze;
  const base = size === 'lg'
    ? 'text-sm px-3 py-1 gap-1.5'
    : 'text-xs px-2 py-0.5 gap-1';
  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${base} ${s.bg} ${s.text} ${s.border}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {labels[tier] || labels.bronze || 'Bronze'}
    </span>
  );
}
